import React from 'react'

const VideoCamIcon = () => {
    return (
        <svg id="videocam_black_24dp_5_" data-name="videocam_black_24dp (5)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_207122" data-name="Path 207122" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_207123" data-name="Path 207123" d="M15,8v8H5V8H15m1-2H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l4,4V6.5l-4,4V7A1,1,0,0,0,16,6Z" fill="rgba(26,26,26,0.8)" />
        </svg>
    )
}

export default VideoCamIcon
